<template>
  <div>
    <!-- <div class="dl_head">
    </div> -->
    <div class="dl_bk">
      <div class="dl_body" style="font-size: 14px">
        <!-- <div class="dl_head_tap">
          <div
            class="taps"
            v-for="(item, index) in taps"
            :key="index"
            :class="{ activetaps: item.active }"
            @click="changetaps(item.active,index)"
          >
            {{ item.text }}
            <div :class="{ activesanjiao: item.active }"></div>
          </div>
        </div> -->
        <div class="kehu" style="padding-top:40px">
          <div class=" dl_gw dl_gw1" v-for="(item, index) in tmsload" :key="index" style="border:none">
            <div
              class="gw_left1"
              :style="{ background: 'url(' + item.img + ') no-repeat top' }"
            ></div>
            <div class="gw_mid">
              <div style="display:flex;justify-content: space-between;">

                <div style="padding-bottom: 6px">
                  <span class="title" style="width:auto"
                    >{{ item.title
                    }}</span
                  >
                </div>
              </div>
                <div class="banben1">
                  {{ item.banben }}
                </div>
            </div>
            <div class="rightpeiz">
                <div>
                  <p style="font-weight:bold;border-left:3px solid #b5734c;color:#b5734c;padding-left:8px;line-height:15px;margin:4px 0">使用应满足的条件：</p>
                  <p>1、CPU要达到四核及以上配置；</p>
                  <p>2、win7/win2008的64位操作系统，4G内存；</p>
                  <p>3、win10/win8的64位操作系统，8G内存；</p>
                  <p>4、建议：使用电信、联通宽带，其它宽带会有卡顿问题。</p>
                </div>
                <div class="gw_right1" v-if="item.idx==1">
                  <div class="djdl" @click="dxdl(item.idx)" style="margin-right:15px">电信下载</div>
                  <div class="djdl1" @click="ltdl(item.idx)" style="margin-right:30px">联通下载</div>
                </div>
                <div class="gw_right1" v-else>
                  <div class="djdl1" @click="dxdl(item.idx)" style="margin-right:15px;">下&nbsp;&nbsp;&nbsp;载</div>
                  <div class="djdl1" style="margin-right:30px;visibility: hidden;">联通下载</div>
                </div>
            </div>
          </div>
          <div class=" dl_gw dl_gw1 dl_gw2" style="border:none">
            <div
              class="gw_left1"
              :style="{ background: 'url(' + tms_phone.img + ') no-repeat top' }"
              style="margin-left:81px"
            ></div>
            <div class="gw_mid">
              <div style="display:flex;justify-content: space-between;">

                <div>
                  <span class="title" style="width:auto"
                    >文华<common-data name="appFullName_TMS"/>&nbsp;-&nbsp;后台管理安卓版</span
                  >
                </div>
              </div>
                <div class="banben1" style="margin-top:7px 0">
                版本:{{tms_phone_load.split("|")[0]}}（第{{tms_phone_load.split("|")[3]}}次修改）&nbsp;&nbsp;大小:{{tms_phone_load.split("|")[2]}}&nbsp;&nbsp; 日期:{{tms_phone_load.split("|")[1]}}
                </div>
            </div>
            <div class="code_img">
              <div class="img_box">
                <div v-if="needRefresh" class="refresh">
                  <img src="../assets/img/R-C.png" alt="" width="40" class="refresh_btn" @click="getCode('/TMS/0-SJ/文华TMS手机版'+ tms_phone_load.split('|')[0]+'.apk')">
                </div>
                <img :src="imgCode" alt="" v-if="imgCode">
                <div v-if="!imgCode" class="imgloading">加载中</div>
              </div>
              <span class="code_text">扫码下载</span>
            </div>
          </div>
          <div style="color:#505050;font-size:16px;text-align:left;margin-bottom:25px">前端软件：</div>
          <div class="dl_gw" v-for="(item, index) in dload" :key="index+'x'" :class="{dshow:(index==1||index==2)&&act==false}">
            <div
              class="gw_left"
              :style="{ background: 'url(' + item.img + ') no-repeat top' }"
            ></div>
            <div class="gw_mid">
              <div style="padding-bottom: 6px">
                <span class="title"
                  >{{ item.title
                  }}<img
                    v-if="item.money"
                    src="../assets/img/shouf.png"
                    alt=""
                    style="position: relative; top: -8px" /></span
                ><span class="banben">{{ item.banben }}</span>
              </div>
              <div
                v-for="(items, indexs) in item.text"
                :key="indexs"
                style="padding: 2px 0"
              >
                {{ items }}
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: initial;
                justify-content: space-between;
              "
            >
              <div class="zhuzhu">{{ item.zhu }}</div>
              <div class="gw_right" v-if="index != dload.length - 1">
                <div class="djdl2" @click="goto(item.url)">体验版</div>
                <div class="djdl2" @click="goto(item.url2)">通用版</div>
              </div>
              <div class="gw_right" v-if="index == dload.length - 1">
                <div class="djdl2" @click="goto(item.url)">体验版/通用版</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <box :message="message" @showbox="showboxx" v-if="showbox"></box>
  </div>
</template>
<script>
import box from "../components/box.vue";
import { jsonp } from "vue-jsonp";
import axios from 'axios';
import _fetchCommonData from '../plugins/FetchCommonData//fetchCommonData.js'
export default {
  components: { box },
  data() {
    return {
      noclick: "noclick",
      iffa: false, //判断两个验证码点击是否生效
      iffa1: false,
      yzm1: "获取验证码", //两个验证码文字
      yzm: "获取验证码",
      newzh: "", //页面文字
      newpwd: "",
      dbnewpwd: "",
      jgzh: "",
      jgmm: "",
      ic: null, //智能验证
      ischeck: false, //是否显示验证
      ifshowzd: false, //是否显示遮挡
      ifshowmm: false, //是否显示账号密码白框
      ifshowxg: false, //是否显示修改密码白框
      ifshowld: false, //是否显示loading
      name: "", //参数
      zhphone: "",
      zhcode: "",
      jgmc: "",
      phone: "",
      code: "",
      sessionid: "",
      token: "",
      sig: "",
      showyzm: false, //判断是发的那个验证码
      showyzm1: false,
      set: null, //两个60秒的读秒轮询
      set1: null,
      ifshowmmtit: "注册成功！",
      act: true,
      taps: [
        {
          text: "私募/团队的业务管理软件",
          active: "",
        },
        {
          text: "期货资管部门的业务管理软件",
          active: "",
        },
      ],
      dqbb: "",
      dqbbplus: "",
      dload: [
        //文案信息
        {
          banben: "",
          text: [
            "针对TMS的客户，提供基本下单、下单任务管理器、网格交易运行池、文件下单等专业下单功能。",
          ],
          img: require("../assets/img/wh7.png"),
          title: "睿期大户室软件基础版",
          url: "https://rich.wenhua.com.cn/#/download?id=false",
          url2: "https://rich.wenhua.com.cn/#/download",
          zhu: "",
          money: false,
        },
        {
          banben: "",
          text: [
            "资金管理层面的专业视角，积木式编程语言、期货化的回测工具、列表式运行管理界面，支持投资组合配置、运行收益分析、单元头寸管理、风险控制...",
          ],
          img: require("../assets/img/wh8.png"),
          title: "",
          url: "https://wt8.wenhua.com.cn/#/download/download/1",
          url2: "https://wt8.wenhua.com.cn/#/download/download/0",
          money: true,
        },
        {
          banben: "",
          text: [
            "针对机构和量化团队，聚焦盘口算法模型开发、回测和自动交易，支持期货、期权的各种复杂交易，也支持算法组件附加到手动交易、趋势量化策略的执行过程中，进行精细化控制，根据盘口行情智能拆单，降低冲击成本，提高交易效率。",
          ],
          img: require("../assets/img/wh9.png"),
          title: "",
          url: "https://wt9.wenhua.com.cn/Download/index?flag=1",
          url2: "https://wt9.wenhua.com.cn/Download/index?flag=0",
          money: true,
        },
        {
          banben: "",
          text: [
            "针对移动终端打造的一款期货交易软件，集行情、交易、云端条件单、银期转账为一身，追求界面简单、功能实用...",
          ],
          img: require("../assets/img/app.png"),
          title: "随身行手机期货投资软件",
          url: "https://app.wenhua.com.cn/download.html",
          url2: "https://app.wenhua.com.cn/download.html",
          money: false,
        },
        // {
        //     banben:'',
        //     text:['文华财经专为股票投资机构精心打造的证券研究软件，wh10聚焦股票的价值分析和量化研究。','在价值分析领域，wh10对A股上市企业进行深度挖掘和整理，推出财务透视、利润滤镜、风险甄别、EVA分析、估值分析等工具，为机构投资者提供了上市企业财务报表勾稽重塑、企业资产和盈利透视、盈利质量和财务风险分析、经济利润考量等功能，并结合机构业绩预测建立了一系列企业内在价值的动态估值模型，帮助投资者快速刻画企业基本面肖像、为决策提供重要参考。','在量化研究领域，wh10打造了涵盖全流程、界面操作式的股票多因子量化平台。提供了包括设定选股范围、选择因子、检验因子有效性、因子时效性参考、分析因子相关性、合成综合因子、生成持仓股票池、净值优化、策略分析报告、调仓建议等功能的全流程多因子量化工具。'],
        //     img:require('../assets/img/wh10.png'),
        //     title:'星格证研价值投资软件',
        //     url:'https://wh10.wenhua.com.cn/index.html?aspxerrorpath=/#/download'
        // }
      ],
      tms_phone:{
        banben: "",
        text: [
          "",
        ],
        img: require("../assets/img/logo_03.png"),
        title: "",
        url: "https://app.wenhua.com.cn/download.html",
        url2: "https://app.wenhua.com.cn/download.html",
        money: false,
        idx:0,
      },
      tmsloadli:[
        {
          banben: "",
          text: [
            "",
          ],
          img: require("../assets/img/logo_01.png"),
          title: "",
          url: "https://app.wenhua.com.cn/download.html",
          url2: "https://app.wenhua.com.cn/download.html",
          money: false,
          idx:0,
        },
        {
          banben: "",
          text: [
            "",
          ],
          img: require("../assets/img/logo_02.png"),
          title: "文华TMS PLUS交易管理系统",
          url: "https://app.wenhua.com.cn/download.html",
          url2: "https://app.wenhua.com.cn/download.html",
          money: false,
          idx:1,
        },
      ],
      tmsload:[
      ],
      tms_phone_load:'',
      smtap: {
        //申请体验账号和找回体验账号的切换
        s1: false,
        s2: false,
      },
      message: "",
      showbox: false,
      imgCode:'',//base64图片地址
      needRefresh:true,
    };
  },
  methods: {
    getCommonData(){
      _fetchCommonData().then((res)=>{
        res.forEach(item => {
          if(item.keyname == 'appShortName_12'){
            this.dload[0].zhu = "注：" + item.value + "基础版只供购买TMS的机构免费使用。";
          }
          if(item.keyname == 'appFullName_11'){
            this.dload[1].title = item.value;
          }
          if(item.keyname == 'appFullName_17'){
            this.dload[2].title = item.value;
          }
          if(item.keyname == 'appFullName_TMS'){
            this.tms_phone.title = "文华" + item.value;
            this.tmsloadli[0].title = "文华" + item.value + " - 后台管理电脑版";
          }
        });
      });
    },
    showboxx(showbox) {
      this.showbox = showbox;
    },
    dxdl(index) {
      //电信联通下载
      if(index==0){

        if (this.dqbb == "") return;
        window.location.href =
          "https://ftpc.wenhua.com.cn/files/TMS/1-GW/文华TMS交易管理系统模拟版-v" +
          this.dqbb.split("|")[0] +
          ".exe";
      }
      else if(index==1){
        
        if (this.dqbbplus == "") return;
        window.location.href =
          "https://ftpc.wenhua.com.cn/files/TMS_Plus/文华TMS-plus交易管理系统模拟版-v" +
          this.dqbbplus .split("|")[0] +
          ".exe";
      }
    },
    ltdl(index) {
      if(index==0){
        if (this.dqbb == "") return;
        window.location.href =
          "https://wenhua-assets.wenhua.com.cn/wenhua/tms_updates/1-GW/文华TMS交易管理系统模拟版-v" +
          this.dqbb.split("|")[0] +
          ".exe";
      }
      else if(index==1){
        if (this.dqbbplus == "") return;
        window.location.href =
          "https://ftpc1.wenhua.com.cn/files/TMS_Plus/文华TMS-plus交易管理系统模拟版-v" +
          this.dqbbplus .split("|")[0] +
          ".exe";
      }
    },

    changetaps(it,idx) {
      //切换两个下载界面
      if (it == false) {
        this.act = !this.act;
        this.taps[0].active = this.act;
        this.taps[1].active = !this.act;
      }
      this.tmsload[0]=this.tmsloadli[idx]
    },

    goto(url) {
      window.open(url, "_blank");
    },
    getbanben() {
      // axios
      //   .post(
      //     "http://wh10.wenhua.com.cn/update/https://www.wenhua.com.cn/api/Update/UpdateGetNew?appid=19&ver=10.0.424&updatetype=lts"
      //   )
      //   .then((res) => {
      //     console.log(res);
      //     if (res.data.Status) {
      //       console.log(1);
      //     }
      //   });
      jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 12,
        t: 0,
      },60000).then((res) => {
        this.dload[0].banben =
          "  版本:" +
          res.split("|")[0] +
          "" +
          " (第" +
          res.split("|")[3] +
          "次修改)" +
          "" +
          " 大小:" +
          res.split("|")[2] +
          "" +
          " 日期:" +
          res.split("|")[1];
      });
      jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 11,
        t: 0,
      },60000).then((res) => {
        this.dload[1].banben =
          "  版本:" +
          res.split("|")[0] +
          "" +
          " (第" +
          res.split("|")[3] +
          "次修改)" +
          "" +
          " 大小:" +
          res.split("|")[2] +
          "" +
          " 日期:" +
          res.split("|")[1];
      });
      jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 17,
        t: 0,
      },60000).then((res) => {
        this.dload[2].banben =
          "  版本:" +
          res.split("|")[0] +
          "" +
          " (第" +
          res.split("|")[3] +
          "次修改)" +
          "" +
          " 大小:" +
          res.split("|")[2] +
          "" +
          " 日期:" +
          res.split("|")[1];
      });
      jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 5,
        t: 0,
      },60000).then((res) => {
        this.dload[3].banben =
          "  版本:" +
          res.split("|")[0] +
          "" +
          " (第" +
          res.split("|")[3] +
          "次修改)" +
          "" +
          " 大小:" +
          res.split("|")[2] +
          "" +
          " 日期:" +
          res.split("|")[1];
      });
      jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 23,
        t: 1,
      },60000).then((res) => {//tms
        this.dqbb = res;
        this.tmsloadli[0].banben='版本:'+ this.dqbb.split("|")[0] +'（第'+this.dqbb.split("|")[3]+'次修改）\u00A0\u00A0大小:'+this.dqbb.split("|")[2]+' \u00A0\u00A0日期:'+this.dqbb.split("|")[1]
      });
       jsonp("https://db.wenhua.com.cn/inc/update.asp", {//tms plus
        appid: 28,
        t: 1,
      },60000).then((res) => {
        console.log(res)
        this.dqbbplus=res
        this.tmsloadli[1].banben='版本:'+ res.split("|")[0] +'（第'+res.split("|")[3]+'次修改）\u00A0\u00A0大小:'+res.split("|")[2]+'\u00A0\u00A0 日期:'+res.split("|")[1]
      });
    },
    getCode(apk){
      let apks = encodeURI(apk)
      axios
        .get(
          "https://m-api.wenhua.com.cn/api/qrcode/GeneratorSignedUrl?plainText="+ apks +"&width=100&height=100"
        )
        .then((res) => {
          if (res.status==200) {
            this.needRefresh=false
            this.imgCode=res.data.resultData
            setTimeout(() => {
              this.needRefresh=true
            }, 1200000);
          }
        });
    },

  },
  created() {
    this.getCommonData()
    jsonp("https://db.wenhua.com.cn/inc/update.asp", {
        appid: 36,
        t: 0,
      },60000).then((res) => {
        this.tms_phone_load=res
        this.getCode('/TMS/0-SJ/文华TMS手机版'+ this.tms_phone_load.split("|")[0]+'.apk')
      });
    this.getbanben();
    this.tmsload.push(this.tmsloadli[0])
    // var mask_bg2 = document.createElement("script");
    // mask_bg2.src='http://g.alicdn.com/mtb/lib-flexible/0.3.4/??flexible_css.js,flexible.js'
    // mask_bg2.async = true
    // mask_bg2.type = 'text/javascript'
    // var mask_bg3 = document.createElement("script");
    // mask_bg3.src='http://g.alicdn.com/sd/smartCaptcha/0.0.4/index.js'
    // mask_bg3.async = true
    // mask_bg3.type = 'text/javascript'
    // var mask_bg4 = document.createElement("script");
    // mask_bg4.src='http://g.alicdn.com/sd/quizCaptcha/0.0.1/index.js'
    // mask_bg4.async = true
    // mask_bg4.type = 'text/javascript'

    // document.head.appendChild(mask_bg2);
    // document.head.appendChild(mask_bg3);
    // document.head.appendChild(mask_bg4);
    this.taps[0].active = this.act;
    this.taps[1].active = !this.act;
  },
  mounted() {},
};
</script>
<style scoped>
input {
  padding-left: 5px;
}
.xgbtn {
  width: 100px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: rgb(68, 141, 243);
  border-radius: 3px;
  border: none;
  color: rgb(255, 255, 255);
  letter-spacing: 2px;
  margin-left: 60px !important;
}
.fhbtn {
  text-decoration: underline;
  height: 28px;
  line-height: 28px;
}
.noclick {
  cursor: not-allowed !important;
}
.zhedang {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 3333;
}
.baikuang {
  background: white;
  min-height: 220px;
  width: 500px;
  position: fixed;
  top: 20%;
  left: 40%;
  text-align: center;
  border-radius: 5px;
  font-size: 15px;
}
.baikuang input {
  width: 196px;
  height: 28px;
  line-height: 28px;
  border: 1px solid rgb(137, 137, 137);
  color: rgb(121, 121, 121);
  font-size: 15px;
  padding: 0px 10px;
}
.baikuang div span {
  display: inline-block;
  width: 150px;
  text-align: right;
  margin-right: 10px;
}
.xhmm {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  width: 100px !important;
  display: inline-block;
}
.close {
  width: 6px !important;
  font-size: 12px;
  text-align: right !important;
  position: absolute;
  right: 10px;
  top: -6px;
  cursor: pointer;
}
.tktitle {
  margin-top: 30px !important;
  font-size: 18px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #848484;
  margin-bottom: 15px;
}
.baikuang div {
  width: 400px;
  margin: 0 auto;
  text-align: left;
  line-height: 38px;
}
.baikuang div p {
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
}
.check {
  /* visibility: hidden; */
  opacity: 0;
  z-index: 55555;
  width: 100px !important;
  overflow: hidden !important;
  left: 274px !important;
}
#sc {
  margin: 0;
  position: absolute;
  bottom: 39px;
  z-index: 11111;
  left: 22px;
}
.ipt {
  margin-top: 58px;
  text-align: left;
  margin-left: 20px;
  color: #848484;
}
.ipt div {
  line-height: 35px;
}
.ipt input {
  width: 250px;
  height: 25px;
  border: 1px solid #d9d9d9;
}
.queding {
  background: #ebb263;
  color: white;
  height: 30px;
  line-height: 30px !important;
  text-align: center;
  width: 120px;
  border-radius: 12px;
  font-size: 16px;
  margin: 20px 120px;
  cursor: pointer;
}
.yzm {
  color: #3d7bdd;
  width: 100px !important;
  margin: 0 10px;
  cursor: pointer;
}
.ipt span {
  display: inline-block;
  width: 80px;
  margin-right: 15px;
  text-align: right;
  letter-spacing: 2px;
}
.huang {
  border-top: 6px #ebb263 solid;
  border-left: 6px #ffffff solid;
  border-right: 6px #ffffff solid;
  position: absolute;
  bottom: -8px;
  left: 47%;
}
.tyzh {
  color: #4e6abf;
  border-bottom: 2px solid #4e6abf;
  float: left;
  margin: 0 20px;
  cursor: pointer;
  position: relative;
}
.activetyzh {
  color: #ebb263;
  border-bottom: 2px solid #ebb263;
}
.rightdl div {
  /* float: left; */
  text-align: center;
}
.rightdl {
  text-align: left;
  position: relative;
  height: 100px;
  margin-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  /* border-bottom: 1px gray dashed; */
}
.dianxdl {
  display: inline-block;
  background: #e8a452;
  color: white;
  height: 39px;
  line-height: 39px;
  width: 130px;
  border-radius: 8px;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
.liantdl {
  display: inline-block;
  margin-left: 20px;
  background: #d09143;
  color: white;
  height: 39px;
  line-height: 39px;
  width: 130px;
  border-radius: 8px;
  font-size: 16px;
  user-select: none;
  cursor: pointer;
}
.tap0left {
  /* float: left; */
  display: inline-block;
  vertical-align: top;
  background: url(../assets/img/guanlixz.png) no-repeat right 75px;
  width: 570px;
  height: 400px;
}
.tap0right {
  width: 575px;
  display: inline-block;
  /* float: left; */
  height: 100%;
  color: #656565;
}
.rightpeiz {
  text-align: left;
  padding: 45px 0 20px 95px;
  line-height: 30px;
  letter-spacing: 1px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.rightpeiz p{
  padding-left: 10px;
}
.dl_head {
  height: 275px;
  background: url(../assets/img/gn-banner.jpg) no-repeat center;
  border-bottom: 4px solid #f4b767;
  position: relative;
}
.dl_body {
  /* min-height: 425px; */
  /* background: url(../assets/img/bg-dl.jpg) no-repeat center; */
  width: 1060px;
  background: white;
  margin: 0 auto;
  height: 100%;
  /* padding-bottom: 120px; */
  box-shadow: 0 0 20px -5px #ccc;
}
.dl_bk {
  background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=77) no-repeat center top,#fafbff;
  padding-top: 138px;
}
.dl_head_tap {
  width: 1060px;
  height: 61px;
  margin: 0 auto;
  border-bottom: 4px solid #f4b767;
}
.taps {
  height: 100%;
  width: 530px;
  text-align: center;
  line-height: 61px;
  background: white;
  position: relative;
  display: inline-block;
  color: #496986;
  font-weight: bold;
  font-size: 17px;
  cursor: pointer;
}
.activetaps {
  background: url(../assets/img/qh-1.jpg) no-repeat center;
  background-size: cover;
  color: #582e08;
}
.activesanjiao {
  width: 15px;
  height: 15px;
  transform: rotate(45deg);
  position: absolute;
  background: #f4b767;
  bottom: -10px;
  z-index: 999;
  left: 263px;
}
.zigdl {
  width: 1145px;
  margin: 0 auto;
  margin-top: 0;
  height: 100%;
  font-size: 14px;
  /* height: 635px; */
  min-height: 490px;
}
.kehu {
  width: 960px;
  margin: 0 auto;
  /* margin-top: 50px; */
  color: #656565;
  padding-bottom: 15px;
}
.dl_gw {
  border-bottom: 1px #bbbbbb dashed;
  padding: 20px 0;
  min-height: 80px;
  vertical-align: top;
}
  .dl_gw1{
      min-height: 0;
    padding-top: 30px;
    margin-bottom: 25px;
    background: #f6f9fc;
  }
.dl_gw:last-child {
  border: none;
}
.gw_left {
  width: 90px;
  padding-right: 20px;
  height: 80px;
  display: inline-block;
  vertical-align: top;
}
.gw_left1 {
  width: 90px;
  padding-right: 20px;
  height: 59px;
  display: inline-block;
  vertical-align: top;
}
.gw_mid {
  display: inline-block;
  height: 100%;
  width: 700px;
  text-align: left;
  vertical-align: top;
}
.gw_right {
  width: 105px;
  padding-left: 20px;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  margin-right: 63px;
}
.gw_right1 {
  padding-left: 20px;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  display: flex;
  margin-right: 0px;
  margin-top: -2px;
}
.title {
  font-size: 16px;
  display: inline-block;
  color: #505050;
  width: 200px;
  font-weight: bold;
}
.banben {
  font-size: 12px;
  color: #adadad;
  display: inline-block;
  margin-left: 120px;
  vertical-align: top;
}
.banben1 {
  font-size: 12px;
  color: #adadad;
  display: inline-block;
  margin-top: 6px;
  vertical-align: top;
}
.djdl {
  background: #67a6dd;
  height: 28px;
  line-height: 28px;
  text-align: center;
  width: 108px;
  color: #ffffff;
  cursor: pointer;
  border-radius: 3px;
}
.djdl1{
  background: #3778b1;
  height: 28px;
  line-height: 28px;
  text-align: center;
  width: 108px;
  color: #ffffff;
  cursor: pointer;
  border-radius: 3px;
}
/* .djdl:hover{
  background: #e6f4ff;
} */
.djdl2 {
  display: inline-block;
  text-decoration: underline;
  color: blue;
  margin-right: 10px;
  cursor: pointer;
}
.czsc {
  line-height: 25px;
  text-align: left !important;
}
.czsc a {
  color: #a0896d;
  text-decoration: underline;
}
.czsc a:visited {
  color: #a0896d;
}
.zhuzhu {
  color: #7d4c3d;
  text-align: left;
  padding-left: 185px;
}
.dshow{
  display: none;
}
.dl_gw2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 30px 0;
}
.code_img {
  background: #d8e2ee;
  padding: 4px;
  display: flex;
  flex-direction: row;
  margin-right: 141px;
}
.code_text {
  color: #3778b1;
  width: 15px;
  padding:10px 8px;
}
.code_a a{
  color: #3778b1;
  text-decoration: none;
}
.code_a a:visited{
  color: #3778b1;
}
.code_a a:hover{
  text-decoration: underline;
}
.img_box{
  position: relative;
}
.refresh{
 position: absolute;
 inset: 0;
 background: rgba(246, 246, 246,0.7);
 display: flex;
 align-items: center;
 justify-content: space-around;
 z-index: 9999;
}
.refresh_btn {
  cursor: pointer;
}
.imgloading{
  height: 100px;
  line-height: 100px;
  text-align: center;
  width: 100px;
}
</style>